module.exports = __webpack_public_path__ + "img/whatsappwhiteoutline.a0027dcc.svg";